import React, { useCallback, useEffect, useRef, useState } from "react";
import AdminHeader from "./Header";
import "../../styles/Super.css";
import { useNotification } from "../../Toast/ToastProvider";
import { adminReqConfig, api, baseURL } from "../../include/api";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronDown } from "react-feather";
import { ERROR, SUCCESS } from "../../include/constant";

const DocumentVerify = () => {
  const { id } = useParams();
  const toast = useNotification();
  const [customerDetail, setCustomerDetail] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [creditBal, setCreditBal] = useState("");
  const [creditLimit, setCreditLimit] = useState("");
  const [showCredit, setShowCredit] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [isProcessed, setIsProcessed] = useState(false);
  const [currentProofStatus, setCurrrentProofStatus] = useState("");
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isNavigating, setIsNavigating] = useState(false);
  const navigate = useNavigate();


  const getCustomerDetail = useCallback(() => {
    setFetchLoading(true);
    api
      .get(`/customer/?id=${id}`, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const customer = response.data.data[0] || null;
          setCustomerDetail(customer);

          if (customer) {
            setCreditBal(customer.creditBal || "");
            setCreditLimit(customer.creditLimit || "");
            setCurrrentProofStatus(customer.proofStatus || "");
          }
        }
      })
      .catch((error) => {
        toast({ type: "error", message: "Failed to load customer detail." });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  }, [id]);

  useEffect(() => {
    getCustomerDetail();
  }, []);

  const addCreditAndLimit = () => {
    if (!creditBal || !creditLimit) {
      toast({ type: ERROR, message: "Please enter creditBal & creditLimit" });
      return;
    }
    const payload = {
      creditBal,
      creditLimit,
    };
    setFetchLoading(true);
    api
      .put(
        `/customer/?id=${id}&flag=changeAdminLimit`,
        payload,
        adminReqConfig()
      )
      .then((response) => {
        if (response.status === 200) {
          toast({
            type: SUCCESS,
            message: "Credit details added successfully!",
          });

          getCustomerDetail();
        }
      })
      .catch(() => {
        toast({ type: "error", message: "Failed to update credit details!" });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  const handleAccept = () => {
    if (!isVerified) {
      toast({ type: ERROR, message: "Please verified document first!" });
      return;
    }
    setFetchLoading(true);
    const payload = {
      proofStatus: "approved",
    };
    api
      .put(
        `customer/?id=${id}&flag=changeProofStatus`,
        payload,
        adminReqConfig()
      )
      .then((response) => {
        if (response.status === 200) {
          toast({ type: SUCCESS, message: "Proof Approved" });
          setCurrrentProofStatus("approved");
          setIsProcessed(true);
          getCustomerDetail();
        }
      })
      .catch(() => {
        toast({ type: ERROR, message: "Failed to proof approved!" });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  const handleReject = () => {
    setFetchLoading(true);
    const payload = {
      proofStatus: "rejected",
    };
    api
      .put(
        `customer/?id=${id}&flag=changeProofStatus`,
        payload,
        adminReqConfig()
      )
      .then((response) => {
        if (response.status === 200) {
          toast({ type: SUCCESS, message: "Proof Rejected" });
          setCurrrentProofStatus("rejected");
          setIsProcessed(true);
          getCustomerDetail();
        }
      })
      .catch(() => {
        toast({ type: ERROR, message: "Failed to proof rejected!" });
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  const handleDownloadSelected = async () => {
    if (selectedDocuments.length === 0) {
      toast({
        type: ERROR,
        message: "Please select at least one document to download",
      });
      return;
    }

    console.log("Selected documents:", selectedDocuments);

    try {
      const ids = JSON.stringify(selectedDocuments);
      console.log("API URL:", `/proof/?id=${ids}&flag=getProofData`);

      const response = await api.get(
        `/proof/?id=${ids}&flag=getProofData`,
        adminReqConfig()
      );

      console.log("API Response:", response);

      if (response.status === 200) {
        const files = response.data.data || [];
        console.log("Files to download:", files);

        if (files.length === 0) {
          toast({ type: ERROR, message: "No documents found!" });
          return;
        }

        const filesToDownload = Array.isArray(files) ? files : [files];
        console.log("Files array:", filesToDownload);

        for (let i = 0; i < filesToDownload.length; i++) {
          const file = filesToDownload[i];
          console.log("Processing file:", file);

          if (!file.proofAttachment) {
            console.error("proofAttachment is missing for file:", file);
            continue;
          }

          const url = baseURL + "/" + file.proofAttachment;
          const filename = file.proofName || `document_${i + 1}`;

          console.log("Downloading:", { url, filename });

          await downloadFile(url, filename, api, adminReqConfig, toast, ERROR);

          if (i < filesToDownload.length - 1) {
            await new Promise((r) => setTimeout(r, 500));
          }
        }

        toast({
          type: SUCCESS,
          message: `Downloaded ${filesToDownload.length} document(s)`,
        });
        setSelectedDocuments([]);
      }
    } catch (error) {
      console.error("Download error:", error);
      toast({ type: ERROR, message: "Failed to download documents!" });
    }
  };

  const downloadFile = async (url, filename) => {
    try {
      const fullUrl = url;
      console.log("Downloading from:", fullUrl);

      const response = await fetch(fullUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 100);
    } catch (error) {
      console.error("Download failed:", error);
      // window.open(fullUrl, "_blank");
    }
  };

  // Function to handle individual document selection
  const toggleDocumentSelection = (docId) => {
    setSelectedDocuments((prev) => {
      if (prev.includes(docId)) {
        return prev.filter((id) => id !== docId);
      } else {
        return [...prev, docId];
      }
    });
  };
  const formatCustomerId = (customer) => {
    if (!customer?.createTimestamp || !customer?.id) return "CUS--";

    // Extract last 2 digits of year
    const year = new Date(customer.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(customer.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `CUS${yy}-${paddedId}`;
  };

  const handleClose = () => {
    setIsNavigating(true);
  if (
    window.confirm(
      "Are you sure you want to leave? Unsaved changes may be lost.",
    )
  ) {
    navigate("/admin/document/documentVerify");
    }
  }

  return (
    <>
      <AdminHeader title={"DOCUMENT VERIFICATION"}>
        <div className="content-wrapper p-0">
          <section
            style={{
              backgroundColor: "#F1F4F9",
              padding: "30px",
              marginTop: "70px",
              marginBottom: "40px",
              minHeight: "90vh",
            }}
          >
            <div className="rounded-5 bg-white py-24">
              <div className="row  px-24 py-10 mb-3">
                <div className="mb-14">
                  <p className="fs-5 fw-bold text-dark">Customer Details</p>
                </div>
                <div className="row mt-24 mb-40">
                  <div className="col-md-2">
                    <p className="fs-6 fw-bold text-dark">Customer ID</p>
                    <p
                      className="fs-6"
                      style={{ color: "#697891", fontWeight: "500" }}
                    >
                      {formatCustomerId(customerDetail)}
                    </p>
                  </div>
                  <div className="col-md-2">
                    <p className="fs-6 fw-bold text-dark">Customer Name</p>
                    <p
                      className="fs-6"
                      style={{ color: "#697891", fontWeight: "500" }}
                    >
                      {customerDetail?.name}
                    </p>
                  </div>
                  <div className="col-md-2">
                    <p className="fs-6 fw-bold text-dark">Phone Number</p>
                    <p
                      className="fs-6"
                      style={{ color: "#697891", fontWeight: "500" }}
                    >
                      {customerDetail?.phoneNumber}
                    </p>
                  </div>
                  <div className="col-md-2">
                    <p className="fs-6 fw-bold text-dark">Email ID</p>
                    <p
                      className="fs-6"
                      style={{ color: "#697891", fontWeight: "500" }}
                    >
                      {customerDetail?.emailId}
                    </p>
                  </div>
                  <div className="col-md-2">
                    <p className="fs-6 fw-bold text-dark">Delivery Address</p>
                    <p
                      className="fs-6"
                      style={{ color: "#697891", fontWeight: "500" }}
                    >
                      {customerDetail?.address1 || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Attached Documents Section */}
            <div className="rounded-5 bg-white py-24 mt-24">
              <div className="row px-24 py-10 mb-3">
                <div className="d-flex justify-content-between align-items-center w-100 mb-14">
                  <p className="fs-5 fw-bold text-dark mb-0">
                    Attached Documents
                  </p>
                  <div>
                    <CustomDropdown
                      handleDownloadCSV={handleDownloadSelected}
                    />
                  </div>
                </div>

                {/* Document Cards */}
                <div className="px-24 py-10">
                  <div
                    className="row g-3 mb-3 px-2 py-10"
                    style={{
                      border: "2px solid #DBE3F3",
                      borderRadius: "5px",
                      marginTop: "10px",
                    }}
                  >
                    {customerDetail?.proof &&
                    customerDetail.proof.length > 0 ? (
                      customerDetail.proof.map((doc, index) => {
                        const docId = doc.id || doc.proofAttachment;
                        const isSelected = selectedDocuments.includes(docId);
                        return (
                          <div
                            key={index}
                            className="col-md-4"
                            style={{ background: "#FAFAFD" }}
                          >
                            <div
                              className="p-3 px-10 py-14 d-flex "
                              style={{
                                border: "1px solid #E3E8F3",
                                borderRadius: "5px",
                              }}
                            >
                              <div className="me-16 document-pdf-background">
                                <img
                                  src="/assets/images/doc-pdf.png"
                                  alt="View"
                                  style={{
                                    width: "35px",
                                    height: "35px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                              <div className="flex-grow-1">
                                <p className="fs-6 fw-bold mb-1">
                                  {doc.proofName || "N/A"}
                                </p>
                                <a
                                  href={baseURL + "/" + doc.proofAttachment}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    window.open(
                                      baseURL + "/" + doc.proofAttachment,
                                      "_blank",
                                    );
                                  }}
                                  className="text-decoration-none fs-6"
                                  style={{
                                    color: "#2592D2",
                                    fontWeight: "500",
                                  }}
                                >
                                  View
                                </a>
                              </div>
                              <div className="ms-2">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{ borderColor: "#c5d5f5" }}
                                  checked={isSelected}
                                  onChange={() =>
                                    toggleDocumentSelection(docId)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12">
                        <p className="text-muted fs-6">
                          No documents attached.
                        </p>
                      </div>
                    )}
                    <div className="mt-24 mb-14">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          style={{ borderColor: "#c5d5f5" }}
                          type="checkbox"
                          id="documentVerified"
                          checked={isVerified}
                          onChange={(e) => setIsVerified(e.target.checked)}
                        />
                        <label
                          className="form-check-label fs-6 fw-bold text-dark ms-14"
                          htmlFor="documentVerified"
                        >
                          Document Verified
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-24 py-10">
                
                {customerDetail.proofStatus === "approved" && (
                  <div>
                    <p className="fs-5 fw-bold text-dark">Set Credit Limit</p>
                    <div className="d-flex align-items-center gap-3 px-20 mt-14">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ borderColor: "#c5d5f5" }}
                        checked={showCredit}
                        onClick={(e) => setShowCredit(e.target.checked)}
                      />
                      <p className="fs-6 text-dark fw-bold mt-2">Show Credit</p>
                    </div>
                    {showCredit && (
                      <>
                        <div className="px-18 py-16">
                          <div
                            className="row px-4 py-30 mt-4"
                            style={{
                              border: "2px solid #DBE3F3",
                              borderRadius: "5px",
                            }}
                          >
                            <div className="col-md-6 mb-3">
                              <label className="form-label fw-bold">
                                Credit limit
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={creditBal}
                                onChange={(e) => setCreditBal(e.target.value)}
                              />
                            </div>
                            <div className="col-md-6 mb-3">
                              <label className="form-label fw-bold">
                                Credit Days
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={creditLimit}
                                onChange={(e) => setCreditLimit(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "end",
                            marginBottom: "10px",
                          }}
                        >
                          <button
                            onClick={addCreditAndLimit}
                            style={{
                              color: "#fff",
                              backgroundColor: "#2b95d3",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "700",
                              cursor: "pointer",
                              padding: "8px 36px",
                              height: "40px",
                              border: "none",
                            }}
                          >
                            Save
                          </button>

                          <button
                            // onClick={handleDownloadPDF}
                            style={{
                              color: "#2692d2",
                              backgroundColor: "#d9ebff",
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: "700",
                              cursor: "pointer",
                              padding: "8px 36px",
                              height: "40px",
                              border: "none",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                            }}
                          >
                            Clear All
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}

                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "20px",
                    }}
                  >
                    <button
                      onClick={handleAccept}
                      disabled={
                        !isVerified ||
                        currentProofStatus === "approved" ||
                        currentProofStatus === "rejected"
                      }
                      style={{
                        color:
                          !isVerified ||
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "#999"
                            : "#fff",
                        backgroundColor:
                          !isVerified ||
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "#ccc"
                            : "#2b95d3",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: "700",
                        cursor:
                          !isVerified ||
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "not-allowed"
                            : "pointer",
                        padding: "8px 36px",
                        height: "40px",
                        border: "none",
                      }}
                    >
                      {currentProofStatus === "approved"
                        ? "Already Accepted"
                        : "Accept"}
                    </button>

                    <button
                      onClick={handleReject}
                      disabled={
                        currentProofStatus === "approved" ||
                        currentProofStatus === "rejected"
                      }
                      style={{
                        color:
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "#999"
                            : "#2692d2",
                        backgroundColor:
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "#eee"
                            : "#d9ebff",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: "700",
                        cursor:
                          currentProofStatus === "approved" ||
                          currentProofStatus === "rejected"
                            ? "not-allowed"
                            : "pointer",
                        padding: "16px 36px",
                        height: "40px",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px",
                      }}
                    >
                      {currentProofStatus === "rejected"
                        ? "Already Rejected"
                        : "Reject"}
                    </button>
                    <button
                      onClick={() => handleClose()}
                      style={{
                        color: "#2692d2",
                        backgroundColor: "#d9ebff",
                        borderRadius: "6px",
                        border: "none",
                        width: "140px",
                        height: "40px",
                        fontSize: "14px",
                        fontWeight: "700",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "background-color 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#b3d7f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#d9ebff";
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
            </div>
          </section>
        </div>
      </AdminHeader>
    </>
  );
};

export default DocumentVerify;

const CustomDropdown = ({ handleDownloadCSV }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Options");
  const dropdownRef = useRef(null);

  const options = [
    { label: "Download", value: "download" },
    // { label: "Import", value: "import" },
  ];
  const handleSelect = (opt) => {
    setSelected(opt.label);
    setIsOpen(false);
    if (opt.value === "download") {
      handleDownloadCSV();
    }
    // else if (opt.value === "import") {
    //     handleOpenImportInstructions();
    // }
  };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  return (
    <div
      ref={dropdownRef}
      className="custom-select"
      style={{ position: "relative", display: "inline-block" }}
    >
      <div
        className="select-header"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          backgroundColor: "#EDF8FA",
          color: "rgba(129, 134, 134, 1)",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          width: "140px",
          height: "40px",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: 500,
        }}
      >
        <span>{selected}</span>
        <ChevronDown />
      </div>
      {isOpen && (
        <ul
          className="select-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            backgroundColor: "white",
            border: "none",
            borderRadius: "4px",
            zIndex: 1000,
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: 500,
          }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              onClick={() => handleSelect(opt)}
              className="select-option"
              style={{
                padding: "8px 12px",
                color: "rgba(129, 134, 134, 1)",
                backgroundColor: "white",
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
